@if (carouselType === CarouselType.recentlyViewed) {
<related-products class="block"
                  [listName]="'Recently products' | translate"
                  [limit]="component.limit"
                  [forbiddenProductIds]="[currentProductId]"
                  [options]="{ engines: ['recent'] }">
    <h2 class="h2 left m-t-2 m-b"
        *iCms="'recently_title' of component"></h2>
</related-products>
} @else if (component.category_id) {
<related-products class="block"
                  [listName]="'Category carousel' | translate"
                  [limit]="component.limit"
                  [options]="{ engines: [{ id: 'category', options: { categoryIds: [component.category_id] } }] }">
    <h2 class="h2 left m-t-2 m-b"
        *iCms="'category_title' of component"></h2>
</related-products>
}